import React from 'react';
export function LocationSection() {
  return <section id="location" className="py-20 bg-white" data-id="element-68">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <div className="flex justify-center" data-id="element-70">
          <div className="relative max-w-4xl w-full" data-id="element-71">
            <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden shadow-xl" data-id="element-72">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sgfZuMuVsxAfB94Eue7WQZ/image.png" alt="Installation de production Materrea avec panneaux solaires" className="w-full h-full object-cover" data-id="element-73" />
            </div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-[#d6c8a9] rounded-full z-0 opacity-60" data-id="element-74"></div>
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#e8e0cc] rounded-full z-0" data-id="element-75"></div>
          </div>
        </div>
      </div>
    </section>;
}